/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullBlogFragment = gql`
  ${BaseBlogFragment}
  ${ImageFragment}
  ${LinkFragment}

  fragment FullBlogFragment on Blog {
    ...BaseBlogFragment

    shareThisPostCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    blogTileImage {
      ...ImageFragment
    }
  }
`;
